import { create } from 'zustand'
import type { DeepWorkSession } from '@/shared/lib/api'

interface DeepWorkState {
  /**
   * Single source of truth for whether a Deep Work session is active.
   * Populated by the `DeepWork` dashboard tile (the only place sessions are
   * started/stopped). Any other component that needs to know "is a session
   * active" (e.g. Focus Mode dimming, see `useFocusMode`) should read from
   * this store rather than tracking its own copy of session state.
   */
  activeSession: DeepWorkSession | null
  setActiveSession: (session: DeepWorkSession | null) => void
}

export const useDeepWorkStore = create<DeepWorkState>((set) => ({
  activeSession: null,
  setActiveSession: (session) => set({ activeSession: session }),
}))
